import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { IframeCommunicationService } from 'src/app/service/iframe';
import { Subscription } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ChangeDetectorRef } from '@angular/core';
import { EnvironmentService } from 'src/app/environment.service';
import interact from 'interactjs';
import { ResetService } from 'src/app/service/widetreset.service';
import { HostListener } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: "app-agent-widget",
  templateUrl: "./agent-widget.component.html",
  styleUrls: ["./agent-widget.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AgentWidgetComponent implements OnInit {
  public settings: Settings;
  public showHoverableChatItem: boolean = false;
  public showChatWindow: boolean = true;
  public chats: Array<any>;
  public talks: Array<any>;
  public interlocutor: string;
  public searchText: string;
  public newChatText: string = "";
  public subscription: Subscription;
  public widgetUrl;
  configuration: any;
  @ViewChild("draggableWidget", { static: true }) draggableWidget!: ElementRef;
  private resetSubscription!: Subscription;
  constructor(
    private resetService: ResetService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private sanitize: DomSanitizer,
    public global: GlobalComponent,
    public appSettings: AppSettings,
    private iframeCommunicationService: IframeCommunicationService,
    public configurationservice: EnvironmentService,
    public router: Router
  ) {
    this.settings = this.appSettings.settings;
    this.configuration =
      this.configurationservice.getEnvironmentsConfiguration();
  }
  @HostListener("window:message", ["$event"])
  onMessage(event: MessageEvent) {
    // Always validate the message origin
    // const trustedOrigin = 'https://your-iframe-origin.com';
    if (event.origin !== this.configuration?.receiveAgentWidgetMessage) return;

    if (event.data?.type === "OPEN_PAGES") {
      let clientData = event.data?.filters;
      console.log(clientData);
      this.newtab(clientData?.clientId)
      
    }
  }
  iframeLoadFailed = false; // Track if iframe fails to load
  loadTimeout: any;
  ngOnInit() {
    setTimeout(() => {
      if (this.resizable) {
        this.resizable.nativeElement.addEventListener("load", () => {
          console.log("Iframe Loaded via JavaScript");
          this.global.isWidgetLoaded = true;
          this.iframeLoadFailed = false; // Reset failure flag
          clearTimeout(this.loadTimeout); // Cancel fallback timeout
        });

        // Set a fallback timeout (e.g., 10 seconds)
        this.loadTimeout = setTimeout(() => {
          if (!this.global.isWidgetLoaded) {
            console.error("Iframe load failed");
            this.global.isWidgetLoaded = true;
            this.iframeLoadFailed = true; // Show error message
          }
        }, 5000); // 5-second timeout
      } else {
        console.error("Iframe not found in DOM");
        this.iframeLoadFailed = true;
      }
    }, 500); // Small delay to ensure iframe is in DOM
    this.subscription = this.iframeCommunicationService.iframeLogout$.subscribe(
      () => {
        this.logoutIframe();
      }
    );
    this.resetSubscription = this.resetService.resetObservable$.subscribe(
      () => {
        this.resetPosition();
      }
    );
    let AgentDetails = {};
    let params = new URLSearchParams();
    params.append("AppColor", "#00786a");
    params.append('AppName','CFSS');
    params.append("AgentAppCode", "CFSS_" +this.global?.agencyCode);
    params.append('AgentType','EMPLOYEE');
    params.append("AgentID", this.global?.userID);
    params.append("AgentName",this.global.fullName);
    params.append('AgentDetails',JSON.stringify(AgentDetails));
    this.widgetUrl = this.sanitize.bypassSecurityTrustResourceUrl(
      this.configuration?.agentWidgeturl + params
    );
    window.addEventListener("message", this.receiveMessage.bind(this), false);
  }
  logoutIframe() {
    const iframe: HTMLIFrameElement = document.getElementById('widgetIframe') as HTMLIFrameElement;
    if (iframe) {
      iframe.contentWindow.postMessage("clearStorage", "*");
      this.settings.theme.showSideChat = false;
    }
  }
  receiveMessage(event: MessageEvent): void {
    // Ensure the message is coming from the expected origin
    if (event.origin !== this.configuration?.receiveAgentWidgetMessage) {
      return;
    }
    // Handle the message received from the iframe
    if (event.data === "notifyJobOffer") {
      // document.getElementById("MadheshReact").click()
      this.settings.theme.showSideChat = true;
      this.cdr.detectChanges();
    }

    // Add more cases as needed to handle different messages
  }

  @ViewChild("dragContainer", { static: false }) dragContainer!: ElementRef;
  @ViewChild("resizable", { static: false }) resizable!: ElementRef;

  ngAfterViewInit() {
    const container = this.dragContainer.nativeElement;
    const iframe = this.resizable.nativeElement.querySelector("iframe");
    const resizeHandle =
      this.dragContainer.nativeElement.querySelector(".resize-handle");

    let lastPointerDownTarget: EventTarget | null = null;
  let isDragging = false;
    // Listen to pointerdown globally on the draggable container
    container.addEventListener("pointerdown", (e) => {
      lastPointerDownTarget = e.target;
    });
    interact(container).draggable({
      inertia: false,
      autoScroll: true,
      allowFrom: ".window-controls",
      // Restrict movement to a specific area of the screen
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const marginTop = height * 0.05; // 10% from top
            const marginBottom = height * 0.1; // 10% from bottom

            return {
              top: marginTop,
              left: 0,
              bottom: height - marginBottom,
              right: width,
            };
          },
         elementRect: { top: 0, left: 0, bottom: 1, right: 1 },
          endOnly: true
        }),

        // Optional: Uncomment to snap to a 20px grid
        // interact.modifiers.snap({
        //   targets: [interact.snappers.grid({ x: 20, y: 20 })],
        //   range: Infinity,
        //   relativePoints: [{ x: 0, y: 0 }]
        // }),
      ],

      listeners: {
        start(event) {
          const downTarget = lastPointerDownTarget as HTMLElement | null;
          const isInsideControls = downTarget?.closest('.window-controls');
  if (iframe) iframe.style.pointerEvents = 'none';
          if (!isInsideControls) {
            event.interaction.stop(); // Prevent dragging if not from window-controls
            return;
          }
          isDragging = true;
  
          const target = event.target;
          target.style.transition = 'none';
          target.style.cursor = 'grabbing';
                  // Add iframe blocker
        const blocker = document.createElement('div');
        blocker.id = 'iframe-blocker';
        blocker.style.position = 'absolute';
        blocker.style.inset = '0';
        blocker.style.zIndex = '9999';
        blocker.style.pointerEvents = 'grabbing';
        container.appendChild(blocker);
        },

        move(event) {
           if (!isDragging) return;
          const target = event.target;

          const prevX = parseFloat(target.getAttribute("data-x") || "0");
          const prevY = parseFloat(target.getAttribute("data-y") || "0");

          const x = prevX + event.dx;
          const y = prevY + event.dy;

          // Apply translate for smooth GPU-accelerated dragging
          target.style.transform = `translate(${x}px, ${y}px)`;

          // Save position for next drag update
          target.setAttribute("data-x", x.toString());
          target.setAttribute("data-y", y.toString());
        },

        end(event) {
          const target = event.target;
          target.style.cursor = "grab";
           if (iframe) iframe.style.pointerEvents = 'auto';
            endDrag(event.target);
        },
      },
    });
  
 const endDrag = (target: any) => {
    if (!isDragging) return;
    isDragging = false;

    target.style.cursor = 'grab';

    const blocker = document.getElementById('iframe-blocker');
    if (blocker) blocker.remove();
  };

  window.addEventListener('pointerup', () => {
    if (isDragging) endDrag(container);
  });

  window.addEventListener('pointerleave', () => {
    if (isDragging) endDrag(container);
  });
  }

  minimizeWindow() {
    this.settings.theme.showSideChat = !this.settings.theme.showSideChat;
    this.global.isMaximized = false;
  }

  // isMaximized = false; // Flag to track widget size

  maximizeWindow() {
    const iframe = this.dragContainer.nativeElement.querySelector("iframe");
    const windowControls =
      this.dragContainer.nativeElement.querySelector(".window-controls");

    if (!this.global.isMaximized) {
      // Maximize the widget
      iframe.style.width = "300px";
      iframe.style.height = "300px";
      iframe.style.minHeight = "250px";
      iframe.style.setProperty("height", "300px", "important");

      windowControls.style.width = "300px"; // Match iframe width
    } else {
      // Restore to default size
      iframe.style.width = "100%";
      iframe.style.height = "620px";
      iframe.style.minHeight = "620px";
      iframe.style.setProperty("height", "620px", "important");

      windowControls.style.width = "100%"; // Match default width
    }

    // Toggle the flag
    this.global.isMaximized = !this.global.isMaximized;
  }

  closeWindow() {}
  resetPosition() {
    if (!this.dragContainer) return;

    const container = this.dragContainer.nativeElement;
    const iframe = container.querySelector("iframe");
    const windowControls = container.querySelector(".window-controls");

    // ✅ Ensure the container is positioned correctly
    this.renderer.setStyle(container, "position", "absolute");
    this.renderer.setStyle(container, "top", "5vw"); // Adjust as needed
    this.renderer.setStyle(container, "right", "10px"); // Adjust as needed
    this.renderer.setStyle(container, "transform", "none"); // Reset transform properly
    this.renderer.setAttribute(container, "data-x", "0"); // Reset data-x
    this.renderer.setAttribute(container, "data-y", "0"); // Reset data-y

    // ✅ Reset cursor to default state
    this.renderer.setStyle(container, "cursor", "grab");

    // ✅ Ensure iframe gets correct size
    if (iframe) {
      this.renderer.setStyle(iframe, "width", "100%");
      this.renderer.setStyle(iframe, "height", "620px");
      this.renderer.setStyle(iframe, "minHeight", "620px");
    }

    // ✅ Ensure window controls have correct width
    if (windowControls) {
      this.renderer.setStyle(windowControls, "width", "100%");
    }
    this.cdr.detectChanges();
  }
  newtab(Clientid) {
    this.global.isClientNewTab = true;
    this.global.EventClientid = Clientid;
    this.global.searchClientStatus = "Active";
    let ClientShortFunctionality = {
      isClientNewTab: this.global.isClientNewTab,
      ClientId: this.global.EventClientid,
    };

    const clientUrl = this.router.serializeUrl(
      this.router.createUrlTree(["/Client"])
    );
   
      window.open("#" + clientUrl, "_blank");
      localStorage.setItem(
        "cfss_ClientNewTabFunctionality",
        JSON.stringify(ClientShortFunctionality)
      );
  }

  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.resetSubscription) {
      this.resetSubscription.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}